<article class="app-dialog-container">
  <header class="share-header">
    @if (finalData) {
      <h1>
        @if (!isEditMode) {
          <mds-icon
            [key]="icons.PLUS_DARK"
            [width]="44"
            [height]="44"
          ></mds-icon>
        }
        {{ finalData.title }}
      </h1>
    }
    <button
      class="button-icon button-ghost"
      aria-label="Close Dialog"
      (click)="close()"
      >
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <mat-dialog-content class="content">
    <form [formGroup]="todoForm" class="scroll-container">
      <div class="sub-container">
        <span class="title">Title <span class="required">*</span></span>
        <input
          class="input-field input-text"
          matInput
          name="title"
          autocomplete="false"
          formControlName="name"
          />
      </div>
      <div class="assign-container">
        <div class="sub-container">
          <span class="title">Assign To <span class="required">*</span></span>
          <div class="custom-input-wrapper input-field auto-search-input">
            <mat-icon matPrefix>search</mat-icon>
            <input
              class="no-border"
              #usrInput
              cdkFocusInitial
              placeholder="Search people to add"
              [matChipInputFor]="chipList"
              [matAutocomplete]="list"
              [formControl]="userControl"
              [matChipInputAddOnBlur]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              (matChipInputTokenEnd)="add(usrInput)"
              />
          </div>
        </div>

        <mat-chip-grid
          #chipList
          [attr.aria-multiselectable]="null"
          [attr.aria-orientation]="null"
          >
          @for (user of selectedUser; track user) {
            <mat-chip-row
              [removable]="removable"
              (removed)="remove(user)"
              >
              {{ isEditMode ? user.name : user }}
              <button matChipRemove aria-label="Remove User" role="button">
                <mds-icon
                  [key]="icons.CLOSE"
                  [width]="20"
                  [height]="20"
                  [pathColors]="['#547080']"
                  class="chip-remover-icon"
                  aria-hidden="true"
                ></mds-icon>
              </button>
            </mat-chip-row>
          }
        </mat-chip-grid>
      </div>

      <mat-autocomplete
        (optionSelected)="updateSelection($event.option, usrInput)"
        #list="matAutocomplete"
        >
        @for (option of optionsList; track option) {
          <mat-option
            class="invite-options"
            [value]="option"
            >
            <div class="options-list">
              @if (option.type == 'user') {
                <img
                  class="avatar"
                  [src]="option.avatar"
                  onerror="this.src='assets/images/avatars/profile.jpg'"
                  alt="User Image"
                  />
              }
              @if (option.type == 'team') {
                <img
                  class="avatar team-icon"
                  style="width: 26px"
                  src="/assets/images/icon-tiny-team.svg"
                  alt="Team Image"
                  />
              }
              <div class="option-detail">
                @if (option.type == 'user') {
                  <span
                    >{{ option.firstname }} {{ option.lastname }}</span
                    >
                  }
                  @if (option.type == 'user') {
                    <span>{{ option.company }}</span>
                  }
                  @if (option.type == 'team') {
                    <span>{{ option.name }}</span>
                  }
                  @if (option.type == 'team') {
                    <span>Team</span>
                  }
                </div>
              </div>
            </mat-option>
          }
        </mat-autocomplete>

        <div class="date-container">
          <div class="sub-container half-width">
            <span class="title">Start date <span class="required">*</span></span>
            <div class="input-field">
              <input
                matInput
                class="no-border input-text"
                name="start date"
                [matDatepicker]="picker1"
                formControlName="start_date"
                />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker1"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </div>
          </div>
          <div class="sub-container half-width">
            <span class="title">Due date <span class="required">*</span></span>
            <div class="input-field">
              <input
                class="no-border input-text"
                matInput
                name="due date"
                [matDatepicker]="picker2"
                formControlName="due_date"
                />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker2"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker2 color="primary"></mat-datepicker>
            </div>
          </div>
        </div>
        <div class="sub-container">
          <span class="title">Notes</span>
          <app-text-editor
            class="full-width"
            [data]="editorNote"
          ></app-text-editor>
        </div>
      </form>
    </mat-dialog-content>

    @if (finalData) {
      <mat-dialog-actions align="end" class="footer">
        <mds-button
          role="button"
          [type]="'secondary'"
          (click)="isEditMode ? cancelEdit() : close()"
          >Cancel</mds-button
          >
          <mds-button
            role="button"
            [type]="'primary'"
            [disabled]="todoForm.status === 'INVALID' || selectedUser.length === 0"
            (click)="isEditMode ? saveEdit() : submitData()"
            >{{ finalData.submit_button_text }}</mds-button
            >
          </mat-dialog-actions>
        }
      </article>
